{
  "schemaVersion": 1,
  "key": "space",
  "name": "Space",
  "version": "1.0.0",
  "author": "classy core",
  "backgrounds": {
    "home": "backgrounds/space3.png"
  },
  "mascot": {
    "home": "mascot/alien2.png"
  },
  "tokens": {
    "accent": "#77A615"
  }
}
